import React, { useState, useEffect } from 'react';

import { useHistory } from "react-router-dom";

import { ReportService } from '../service/ReportService';
import { ReportModal } from './ReportModal';
import { ProgressSpinner } from 'primereact/progressspinner';

import ReactGA from 'react-ga';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export function ReportCardWithThumbnail(props) {

    const history = useHistory();
    const [favorite, isFavorite] = useState(false);
    const [opening, isOpening] = useState(false);
    const [client] = useState(props.client);
    const [report] = useState(props.report);
    const [embedConfig, setEmbedConfig] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const reportService = new ReportService();

    const [showExclusiveContentModal, setShowExclusiveContentModal] = useState(false);
    const [exclusiveContentPlan, setExclusiveContentPlan] = useState("");
    
    useEffect(() => {
        async function fetchData() {
            isFavorite(reportService.isReportFavorite(props.report));
        }        
        fetchData();
    }, []);


    const toggleFavorite = async (flag) => {
        await reportService.toggleReportAsFavorite(report, flag);
        isFavorite(flag);
    }

    const openReport = async () => {
        try {
            const accessCheck = await reportService.checkAccess(client, report);
            const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
            if(accessCheck.hasAccess){
                
                isOpening(true);
                if((report.config.type || "PBI_EMBED") === "PBI_EMBED"){
                    setEmbedConfig(await reportService.getEmbedConfig(client, report));
                }

                const gaData = {
                    path: `${loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/reports/${report.id}`,
                    title: `${loggedInUser.client ? loggedInUser.client.name + ' - ': ''}Relatórios - ${report.name}`
                }

                ReactGA.pageview(gaData.path, null, gaData.title);

                setShowReport(true);
                isOpening(false);
            }
            else {
                console.log(accessCheck);
                
                if(accessCheck.plans && accessCheck.plans.length > 0){
                    setExclusiveContentPlan(accessCheck.plans[0]);
                    setShowExclusiveContentModal(true);
                }
            }
            
        } catch (error) {
            console.log(error);
            throw error;   
        }
    }

    return <>
        { showExclusiveContentModal &&
        <Dialog 
                    visible={true} 
                    style={{ width: '50vw' }} 
                    header={<div style={{padding: '20px', fontSize: '24px'}}>Conteúdo Exclusivo</div>}
                    modal 
                    className="p-fluid" 
                    footer={<>
                        <Button label={"Assinar"} className="p-button-text" 
                            style={{ fontSize: '28px', color: '#fff', backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}}
                            onClick={() => {
                            const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
                            history.push(`${loggedInUser.client && !loggedInUser.client.use_custom_url ? `/${loggedInUser.client.shortcode}` : ''}/subscriptions/plans?p=${ exclusiveContentPlan.id }`)
                        }} />
                        <Button label={"Não, obrigado"} className="p-button-text" onClick={() => setShowExclusiveContentModal(false)} />
                    </>} 
                    onHide={() => setShowExclusiveContentModal(false)}>
                    <div style={{padding: '20px', fontSize: '24px'}}>Para acessar este conteúdo você precisa ser assinante do plano <b>{ exclusiveContentPlan.name }</b>.</div>
        </Dialog>
        }
        <div key={`report_card_${report.id}`} className="p-col-12 p-md-6 p-lg-3" style={{marginRight: '10px', minWidth: '400px'}}>
            <div className="p-grid" style={{ borderRadius: 10, padding: 10, backgroundColor: '#dddddd'}}>
                {
                    props.thumbnail && 
                    <div className="p-col-12 p-lg-12" style={{overflow: 'hidden'}}>
                        <img src={props.thumbnail.content} style={{maxHeight: '150px'}}/>
                    </div>
                }
                <div className="p-col-12 p-lg-10">
                    <h3 style={{fontWeight: 'bolder', color: client.custom_layout.primaryBackgroundColor}} dangerouslySetInnerHTML={{__html: report.name}}></h3>
                </div>
                <div className="p-col-12 p-lg-2">
                    { favorite ? 
                        <span className="pi pi-star" style={{'fontSize': '2em', cursor: 'pointer'}} onClick={() => toggleFavorite(false)}></span> 
                    : 
                        <span className="pi pi-star-o" style={{'fontSize': '2em', cursor: 'pointer'}} onClick={() => toggleFavorite(true)}></span> 
                    }
                </div>
                <div className="p-col-12 p-lg-10" style={{overflow: 'hidden'}}>
                    <span className="detail" dangerouslySetInnerHTML={{__html: report.description}}></span>
                </div>
                <div className="p-col-12 p-lg-2">
                    { opening ? 
                        <ProgressSpinner style={{width: '2em'}} strokeWidth="4" fill="#cccccc"></ProgressSpinner> 
                    : 
                        <span className={`pi ${ report.has_access ? 'pi-arrow-circle-right' : 'pi-lock'}`} style={{'fontSize': '2em', cursor: 'pointer', marginTop: '25px'}} onClick={openReport}></span> 
                    }
                </div>
            </div>
        </div>
        { showReport && <ReportModal report={report} embedConfig={embedConfig} onHide={() => setShowReport(false)}/>}
    </>;

}